import { useState } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Container } from "react-bootstrap";
import pdfFile1 from "../../public//Files//career//Blog-Space to Soil How Satellites Are Revolutionizing Agriculture and Boosting Wheat Production.pdf";
import pdfFile2 from "../../public//Files//career//Blog-The Herbal Industry Boom.pdf";
import pdfFile3 from "../../public//Files//career//Blog-Water Management Techniques for Rabi Oilseed Crops.pdf";
import pdfFile4 from "../../public//Files//career//Blog-What is a Spectral Library.pdf";
import pdfFile5 from "../../public//Files//career//Blog-Wheat and CC.pdf";
import pdfFile6 from "../../public//Files//career//Blog-Wheat Optimal Plant Population via Drill Sowing Method.pdf";
import pdfFile7 from "../../public//Files//career//Blog-Winter Cover Crops for Orchards-A Boon for Soil Health and Erosion Control.pdf";
import pdfFile8 from "../../public//Files//career//Blog-Winter Fertilization Preparing Fruit Trees for a Productive Spring.pdf";
import pdfFile9 from "../../public//Files//career//Blog Branding Pakistan Agri-Products for Export.pdf";
import pdfFile10 from "../../public//Files//career//Blog on Setting Up Small Agro Processing Units in Rural Areas A Path to Economic Growth and Food Security.pdf";
import pdfFile11 from "../../public/Files//career//Blog on Digital Farming Is Pakistan Ready for the AgTech Revolution.pdf";
import "../../../src/App.css";
import lims_logo from "../../public/media/combined_images/logo.png"

function truncateText(text, limit) {
  const words = text.split(" ");
  if (words.length > limit) {
    return words.slice(0, limit).join(" ") + "...";
  }
  return text;
}

function Career() {
  const [showModal, setShowModal] = useState(false);
  const [modalPdfUrl, setModalPdfUrl] = useState("");

  const cardData = [
    {
      title:
        "Blog-Space to Soil How Satellites Are Revolutionizing Agriculture and Boosting Wheat Production",
      text: "Publishing Date: 2024-09-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile1, // Replace with the PDF file URL for this card
    },
    {
      title: "Blog-The Herbal Industry Boom",
      text: "Publishing Date: 2024-08-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile2, // Replace with the PDF file URL for this card
    },
    {
      title: "Blog-Water Management Techniques for Rabi Oilseed Crops",
      text: "Publishing Date: 2024-09-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile3, // Replace with the PDF file URL for this card
    },
    {
      title: "Blog-What is a Spectral Library",
      text: "Publishing Date: 2024-10-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile4, // Replace with the PDF file URL for this card
    },
    {
      title: "Blog-Wheat and CC",
      text: "Publishing Date: 2024-08-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile5, // Replace with the PDF file URL for this card
    },
    {
      title: "Blog-Wheat Optimal Plant Population via Drill Sowing Method",
      text: "Publishing Date: 2024-09-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile6, // Replace with the PDF file URL for this card
    },
    {
      title:
        "Blog-Winter Cover Crops for Orchards-A Boon for Soil Health and Erosion Control",
      text: "Publishing Date: 2024-10-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile7, // Replace with the PDF file URL for this card
    },
    {
      title:
        "Blog-Winter Fertilization Preparing Fruit Trees for a Productive Spring",
      text: "Publishing Date: 2024-10-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile8, // Replace with the PDF file URL for this card
    },

    // ------------------------

    {
      title:
        "Blog-Branding Pakistan Agri-Products for Export: Global Unlocking",
      text: "Publishing Date: 2025-08-18",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile9, // Replace with the PDF file URL for this card
    },

    {
      title:
        "Blog-Setting Up Small Agro-Processing Units in Rural Areas A Path to Economic Growth and Food Security",
      text: "Publishing Date: 2025-08-18",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile10, // Replace with the PDF file URL for this card
    },

    {
      title:
       "Blog-Digital Farming Is Pakistan Ready for the AgTech Revolution",
      text: "Publishing Date: 2025-08-21",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile11, // Replace with the PDF file URL for this card
    },
  ];

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = (modalPdfUrl) => {
    setModalPdfUrl(modalPdfUrl);
    setShowModal(true);
  };

 return (
  <Container>
    {/* Inject CSS keyframes for floating & pulse effects */}
    <style>
      {`
        @keyframes floatLogo {
          0% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-8px) scale(1.03); }
          100% { transform: translateY(0px) scale(1); }
        }
      `}
    </style>

    <Row xs={1} md={3} className="g-4" style={{ marginTop: "20px" }}>
      {cardData.map((card, idx) => (
        <Col key={idx} xs={12} sm={6} md={4}>
          <Card
            style={{
              background: "#F5F7FB",
              borderRadius: "25px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "14px",
              height: "390px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Card.Body
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Card.Title
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {truncateText(card.title, 5)}
              </Card.Title>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <img
                  src={card.logo1}
                  alt="Logo"
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                    marginRight: "10px",
                  }}
                />
                <span>{card.text}</span>
              </div>

              <hr style={{ margin: "5px 0 15px 0" }} />

              {/* Animated Center Logo Section */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={card.logo1}
                  alt="Centered Animated Logo"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain",
                    opacity: 0.85,
                    animation: "floatLogo 3s ease-in-out infinite",
                    filter: "drop-shadow(0px 8px 12px rgba(0, 0, 0, 0.08))",
                  }}
                />
              </div>
            </Card.Body>

            <Card.Footer
              className="text-center"
              style={{
                background: "#0e97ff",
                borderRadius: "17px",
                padding: "10px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Button
                onClick={() => handleShowModal(card.modalPdfUrl)}
                style={{
                  borderRadius: "8px",
                  width: "150px",
                  background: "#e5e8ef",
                  border: "1px solid #dfe2e",
                  color: "black",
                }}
              >
                {card.buttonText}
              </Button>
              <a href={card.modalPdfUrl} download="example.pdf">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/15525/15525195.png"
                  alt="Download"
                  style={{
                    height: "50px",
                    width: "auto",
                    marginLeft: "10px",
                  }}
                />
              </a>
            </Card.Footer>
          </Card>
        </Col>
      ))}
    </Row>

    <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div
          style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
        >
          <iframe
            src={modalPdfUrl}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
            }}
            title="PDF Viewer"
          ></iframe>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  </Container>
);
}

export default Career;
